import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import styled from "styled-components";
import * as Yup from "yup";
import { FiAlertCircle, FiX } from "react-icons/fi";

import { Col, Modal, Row } from "react-bootstrap";
import LogInput from "../../../../components/atoms/LogInput";
import { COLOR_GRAY_TEXT, COLOR_PRIMARY } from "../../../../constants/Colors";
import { errorToast, successToast } from "../../../../services/toastService";
import LogButton from "../../../../components/atoms/LogButton";
import {
  changeTomador,
  getAllTomador,
  getAllUsers,
  getDetailTrip,
  getTUnitsById,
  getUsers,
} from "../../../../api/modules";
import LogSelect from "../../../../components/atoms/LogSelect";
import { getDriversByTomador } from "../../../../api/modules/driver";

const ModalLogStyled = styled(Modal)`
  opacity: 1;
  .modal-content {
    border-radius: 15px !important;
    padding: 20px;
  }
  p {
    color: ${COLOR_GRAY_TEXT};
  }
`;
const Divider = styled.hr`
  background-color: ${COLOR_PRIMARY};
  width: 1px;
  height: 90%;
  opacity: 0.3;
  margin: "auto";
`;
const DocumentContainer = styled(Row)`
  max-height: 200px;
  overflow: auto;
`;

const ContentModal = styled.div`
  text-align: center;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 20px;
  color: #000;
  &:hover {
    color: #ff0000;
  }
`;

const ChangeTomador = ({ isShow, handleClose, tripDetail, refetch }) => {
  const [data, setData] = useState({});
  const [driver, setDriver] = useState([]);
  const [users, setUsers] = useState([]);
  const [trailer, setTrailer] = useState([]);
  const [truck, setTruck] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  let ProfileSchema = null;

  if (data?.discount_factor) {
    ProfileSchema = Yup.object().shape({
      id_tomador: Yup.string().nullable().required("Tomador es requerido"),
      id_driver: Yup.string().nullable().required("Chofer es requerido"),
      id_truck: Yup.string().nullable().required("Camión es requerido"),
      id_trailer: Yup.string().nullable().required("Acoplado es requerido"),
      discount_tomador: Yup.number()
        .nullable()
        .required("Descuento requerido")
        .min(0, "No puede ser menor a 0")
        .max(99.99, "No puede superar el 99.99")
        .test(
          "decimal-places",
          "Debe tener como máximo dos decimales",
          (value) =>
            value === undefined ||
            value === null ||
            /^\d+(\.\d{1,2})?$/.test(value.toString())
        ),
      discount_trip: Yup.number()
        .nullable()
        .required("Descuento requerido")
        .min(0, "No puede ser menor a 0")
        .max(99.99, "No puede superar el 99.99")
        .test(
          "decimal-places",
          "Debe tener como máximo dos decimales",
          (value) =>
            value === undefined ||
            value === null ||
            /^\d+(\.\d{1,2})?$/.test(value.toString())
        ),
    });
  } else {
    ProfileSchema = Yup.object().shape({
      id_tomador: Yup.string().nullable().required("Tomador es requerido"),
      id_driver: Yup.string().nullable().required("Chofer es requerido"),
      id_truck: Yup.string().nullable().required("Camión es requerido"),
      id_trailer: Yup.string().nullable().required("Acoplado es requerido"),
      discount_tomador: Yup.number()
        .nullable()
        .required("Descuento requerido")
        .min(0, "No puede ser menor a 0")
        .max(99.99, "No puede superar el 99.99")
        .test(
          "decimal-places",
          "Debe tener como máximo dos decimales",
          (value) =>
            value === undefined ||
            value === null ||
            /^\d+(\.\d{1,2})?$/.test(value.toString())
        ),
    });
  }
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: {
      id_tomador: null,
      id_driver: null,
      discount_tomador: null,
      discount_trip: null,
      id_truck: null,
      id_trailer: null,
    },
    onSubmit: async (values) => {
      const resp = await changeTomador(tripDetail, values);
      const { msg } = resp;
      if (msg) {
        errorToast(msg || "Intente nuevamente");
        resetForm();
      } else {
        successToast(`Tomador cambiado exitosamente`);
        handleClose();
      }
    },
    validationSchema: ProfileSchema,
  });

  const fetchData = async () => {
    setIsLoading(true);
    const { TripDetail, msg } = await getDetailTrip(tripDetail);
    const { users } = await getAllTomador();
    if (Array.isArray(users)) {
      setUsers(users);
    }
    if (msg) {
      errorToast(msg || "Intente nuevamente");
    } else {
      setData(TripDetail);
    }
    setIsLoading(false);
  };
  const fetchDrivers = async (id) => {
    const { driversByTC } = await getDriversByTomador(id);
    if (Array.isArray(driversByTC)) {
      const tomador = users?.find((user) => user._id === id);

      setDriver([tomador, ...driversByTC]);
    } else {
      setDriver([]);
    }
  };

  const fetchUnits = async (id) => {
    const { trucks } = await getTUnitsById(id);
    if (Array.isArray(trucks)) {
      setTruck(trucks.filter((truck) => truck?.truck_type === "1"));
      setTrailer(trucks.filter((truck) => truck?.truck_type === "2"));
    } else {
      setTruck([]);
      setTrailer([]);
    }
  };

  useEffect(() => {
    if (tripDetail) {
      fetchData();
    }
  }, [tripDetail]);
  useEffect(() => {
    if (values?.id_tomador) {
      const fetchTomadorData = async () => {
        try {
          await Promise.all([
            fetchDrivers(values.id_tomador),
            fetchUnits(values.id_tomador),
          ]);
        } catch (error) {
          console.error("Error al obtener datos del tomador", error);
        }
      };

      fetchTomadorData();
    } else {
      setDriver([]);
      setTruck([]);
      setTrailer([]);
      resetForm();
    }
  }, [values?.id_tomador]);

  return (
    <ModalLogStyled
      show={isShow && !isLoading}
      enforceFocus={false}
      onHide={() => {
        resetForm();
        handleClose();
      }}
      size={"xl"}
      centered
      className="modal-exit"
    >
      <Modal.Header>
        <CloseButton
          onClick={() => {
            resetForm();
            handleClose();
          }}
        >
          <FiX />
        </CloseButton>
      </Modal.Header>
      <Modal.Body className="pt-0">
        <Row>
          <Col className="text-left">
            <h4 className="font-weight-bold text-primary h5">
              {"ID Viaje " +
                (data.parent_id && data.order
                  ? data.parent_id + data.order
                  : "No posee")}
            </h4>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Row>
              <Col className="mb-3">
                <label className="black-primary font-weight-bold mb-0">
                  Tomador{" "}
                </label>
                <LogInput
                  type="text"
                  value={
                    `${data?.id_tomador?.name} ${data?.id_tomador?.last_name} (${data?.id_tomador?.cuit})` ||
                    "No Informado"
                  }
                  className={`mt-1 py-2`}
                  errors={{}}
                  readOnly
                />
              </Col>
            </Row>
            {data?.discount_trip ? (
              <Row>
                <Col xs={6}>
                  <label className="black-primary font-weight-bold mb-0">
                    Comisión Tomador
                  </label>
                  <LogInput
                    type="text"
                    value={`${data?.discount_tomador} %` || "No Informado"}
                    errors={{}}
                    className="mb-3 py-2 mt-1"
                    readOnly
                  />
                </Col>
                <Col xs={6}>
                  <label className="black-primary font-weight-bold mb-0">
                    Comisión Viaje
                  </label>
                  <LogInput
                    type="text"
                    value={`${data?.discount_trip} %` || "No Informado"}
                    errors={{}}
                    className="mb-3 py-2 mt-1"
                    readOnly
                  />
                </Col>
              </Row>
            ) : (
              <Col>
                <Row>
                  <label className="black-primary font-weight-bold mb-0">
                    Comisión{" "}
                  </label>
                  <LogInput
                    type="text"
                    value={`${data?.discount_tomador} %` || "No Informado"}
                    errors={{}}
                    className="mb-3 py-2 mt-1"
                    readOnly
                  />
                </Row>
              </Col>
            )}

            <label className="black-primary font-weight-bold mb-0">
              Chofer
            </label>
            <LogInput
              type="text"
              className="py-1 mt-1 mb-3"
              value={
                data?.id_driver
                  ? `${data?.id_driver?.name} ${data?.id_driver?.last_name} (${data?.id_driver?.cuit})`
                  : `${data?.id_tomador?.name} ${data?.id_tomador?.last_name} (${data?.id_tomador?.cuit})` ||
                    "No Informado"
              }
              errors={{}}
              readOnly
            />
            <Row>
              <Col xs={6}>
                <label className="black-primary font-weight-bold mb-0">
                  Camión
                </label>
                <LogInput
                  type="text"
                  value={`${data?.id_truck?.domain} `}
                  errors={{}}
                  className="mb-3 py-2 mt-1"
                  readOnly
                />
              </Col>
              <Col xs={6}>
                <label className="black-primary font-weight-bold mb-0">
                  Trailer
                </label>
                <LogInput
                  type="text"
                  value={`${data?.id_trailer?.domain} `}
                  errors={{}}
                  className="mb-3 py-2 mt-1"
                  readOnly
                />
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col className="mb-3">
                <label className="black-primary font-weight-bold mb-0">
                  Nuevo Tomador
                </label>
                <LogSelect
                  placeholder="CUIT - MAIL"
                  name="id_tomador"
                  placement="autoVerticalStart"
                  style={{ height: "38px" }}
                  items={users?.map((ele) => {
                    return {
                      label: "Cuit: " + ele.cuit + "   " + "Mail: " + ele.email,
                      value: ele._id,
                    };
                  })}
                  onChange={async (v) => {
                    setFieldValue("id_tomador", v);
                    if (data?.discount_trip) {
                      setFieldValue(
                        "discount_tomador",
                        users?.find((user) => user?._id === v)?.discount_factor
                      );
                    }
                  }}
                  className="mt-0 py-0 "
                  searchable={true}
                  onBlur={handleBlur("id_tomador")}
                  errors={errors}
                  value={values.id_tomador}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={6}>
                <label className="black-primary font-weight-bold mb-0">
                  Comisión Tomador
                </label>
                <LogInput
                  type="text"
                  value={
                    users?.find((user) => user?._id === values?.id_tomador)
                      ?.discount_factor
                      ? `${
                          users.find((user) => user?._id === values?.id_tomador)
                            ?.discount_factor
                        } %`
                      : ""
                  }
                  errors={{}}
                  className="mb-3 py-2 mt-1"
                  readOnly
                />
              </Col>
              {data?.discount_trip ? (
                <Col xs={6}>
                  <label className="black-primary font-weight-bold mb-0">
                    Comisión Viaje
                  </label>
                  <LogInput
                    type="text"
                    value={values.discount_trip}
                    errors={errors}
                    onChange={(e) => {
                      const re = /^[0-9]*(\.[0-9]{0,2})?$/;
                      if (re.test(e.target.value)) {
                        handleChange(e);
                      }
                    }}
                    handleBlur={handleBlur["discount_trip"]}
                    className="mb-3 py-2 mt-1"
                    name="discount_trip"
                  />
                </Col>
              ) : (
                <Col xs={6}>
                  <label className="black-primary font-weight-bold mb-0">
                    Asignar Comisión
                  </label>
                  <LogInput
                    type="text"
                    value={values.discount_tomador}
                    errors={errors}
                    onChange={(e) => {
                      const re = /^[0-9]*(\.[0-9]{0,2})?$/;
                      if (re.test(e.target.value)) {
                        handleChange(e);
                      }
                    }}
                    handleBlur={handleBlur["discount_tomador"]}
                    className="mb-3 py-2 mt-1"
                    name="discount_tomador"
                  />
                </Col>
              )}
            </Row>
            <Row className="mb-3">
              <Col>
                <label className="black-primary font-weight-bold mb-0">
                  Nuevo Chofer
                </label>
                <LogSelect
                  placeholder="CUIT - MAIL"
                  defaultValue={""}
                  placement="topStart"
                  name="id_driver"
                  style={{ height: "38px" }}
                  items={driver?.map((ele) => {
                    return {
                      label: "Cuit: " + ele.cuit + "   " + "Mail: " + ele.email,
                      value: ele._id,
                    };
                  })}
                  onChange={async (v) => {
                    setFieldValue("id_driver", v);
                  }}
                  className="mt-0 py-0"
                  searchable={true}
                  onBlur={handleBlur("id_driver")}
                  errors={errors}
                  value={values.id_driver}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={6}>
                <label className="black-primary font-weight-bold mb-0">
                  Nuevo Camión
                </label>
                <LogSelect
                  placeholder="Dominio"
                  defaultValue={""}
                  placement="topStart"
                  name="id_truck"
                  style={{ height: "38px" }}
                  items={truck?.map((ele) => {
                    return {
                      label: ele.domain,
                      value: ele._id,
                    };
                  })}
                  onChange={async (v) => {
                    setFieldValue("id_truck", v);
                  }}
                  className="mt-0 py-0"
                  searchable={true}
                  onBlur={handleBlur("id_truck")}
                  errors={errors}
                  value={values.id_truck}
                />
              </Col>
              <Col xs={6}>
                <label className="black-primary font-weight-bold mb-0">
                  Nuevo Trailer
                </label>
                <LogSelect
                  placeholder="Dominio"
                  defaultValue={""}
                  placement="topEnd"
                  name="id_trailer"
                  style={{ height: "38px" }}
                  items={trailer?.map((ele) => {
                    return {
                      label: ele.domain,
                      value: ele._id,
                    };
                  })}
                  onChange={async (v) => {
                    setFieldValue("id_trailer", v);
                  }}
                  className="mt-0 py-0"
                  searchable={true}
                  onBlur={handleBlur("id_trailer")}
                  errors={errors}
                  value={values.id_trailer}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="footer-modal">
        <Col className="d-flex justify-content-center mt-2">
          <LogButton
            /* className="w-md-50" */
            color="primary"
            onClick={handleSubmit}
            title={"Cambiar tomador"}
            border="curve"
          />
        </Col>
      </Modal.Footer>
    </ModalLogStyled>
  );
};

export default ChangeTomador;
